import React from "react";
import styled from "styled-components";
import Icon from "@mui/icons-material/Link";

const CustomLinkIcon = styled(Icon)`
  background-color: ${(p) => p.theme.palette.primary.main};
  border-radius: 20px;
  color: #fff;
  padding: 5px;
  position: absolute;
  top: -43px;
`;

export const LinkIcon = () => {
  return (
    <div style={{ position: "relative" }}>
      <CustomLinkIcon />
    </div>
  );
};
